<!--@format-->
<template>
    <div class="landing-page-select-widget">
        <div class="widget-header">
            <div class="title-container">
                <h3>Select Landing Page</h3>
            </div>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <cards-list-widget
                :multiple="false"
                same-size
                :items="items"
                :tooltips-text="cardsTooltipsText"
                :loading="loading"
                @search="handleUpdateSearch"
                @show-preview="handleShowPreview"
                @input="handleInputSelect"
                @unselect="handleRemoveItem"
            />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
            </div>
            <div class="action-container">
                <app-button :disabled="isButtonDisabled" @click="handleAddLink"> Add </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const CardsListWidget = () => import('@/components/sliding-widgets/cards-list-widget');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');

import EventBus from '@/scripts/event-bus.js';
import { LandingPageBoardServiceMixin } from '@/mixins/board/landing-page-board-service-mixin';
import { isNil } from 'lodash';

export default {
    name: 'landing-page-select-widget',

    components: {
        'app-button': AppButton,
        'cards-list-widget': CardsListWidget,
        'widget-close-svg': WidgetCloseSvg,
    },

    mixins: [LandingPageBoardServiceMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },

        options: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            loading: true,
            selectedItem: null,
            items: [],
            totalItems: 0,
            cardsTooltipsText: {
                preview: 'Preview',
                close: 'Deselect Template',
            },
        };
    },

    computed: {
        isButtonDisabled() {
            return isNil(this.selectedItem);
        },

        templatePreviewPlaceHolder() {
            return 'https://cdn.honeycrm.com/app/Email-Template-Preview-Placeholder.png';
        },
    },

    created() {
        this.getData();
    },

    methods: {
        getData(options = {}) {
            this.loading = true;
            this.items = [];

            this.dispatchGetLandingPages('Published', options)
                .then(({ items, count }) => {
                    this.items = this.asCardItems(items);
                    this.totalItems = count;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while fetching your published landing pages.',
                        { error },
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        asCardItems(items) {
            return items.map(({ landingPage }) => ({
                id: landingPage.id,
                previewName: landingPage.name,
                previewImage: landingPage.thumbnailImageUrl || this.templatePreviewPlaceHolder,
                url: landingPage.url,
            }));
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handleInputSelect(item) {
            [this.selectedItem] = item;
        },

        handleRemoveItem() {
            this.selectedItem = null;
        },

        handleShowPreview({ url }) {
            window.open(url, '_blank');
        },

        handleUpdateSearch(searchValue) {
            const options = {
                search: searchValue,
                filters: {
                    operation: 'And',
                    value: [],
                },
            };

            this.getData(options);
        },

        handleAddLink() {
            if (this.selectedItem) {
                if (this.options.eventName) {
                    EventBus.$emit(this.options.eventName, this.selectedItem);
                } else {
                    EventBus.$emit('landing-page-link:select', this.selectedItem);
                }
            }

            this.closeWidget();
        },
    },
};
</script>

<style>
.landing-page-select-widget .content-wrapper {
    padding: 20px;
}

.landing-page-select-widget .transparent-btn {
    background: transparent;
    color: #877d88;
}

.landing-page-select-widget .transparent-btn:hover {
    background: #e1e0e5;
}

.landing-page-select-widget .collateral-display .master-card-wrapper > .card {
    margin-right: 11px;
}

.landing-page-select-widget
    .master-display.collateral-display
    .master-card-controls
    .custom-filter-container {
    right: -200px;
}
</style>
